import { Building2, TrendingUp } from 'lucide-react';

export const Guarantee = {
  title: 'Our guarantee',
  tagline: 'Facade specialists, with results you can see.',
  promises: [
    {
      id: 'specialists',
      icon: Building2,
      title: 'Only facade companies',
      description: 'We work only with facade installers and manufacturers, so you never pay for us to learn your industry.',
    },
    {
      id: 'reporting',
      icon: TrendingUp,
      title: 'Results in plain numbers',
      description: 'Every month you see the leads, meetings, and bid invites our work produced.',
    },
  ],
};